"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RemoveVoucherEvent = exports.Name = void 0;
const Name = exports.Name = 'remove-voucher';
const RemoveVoucherEvent = exports.RemoveVoucherEvent = Name;
//# sourceMappingURL=index.js.map